import { Card,CardMedia,CardContent,Typography,CardActions,Button,Box,Divider } from '@mui/material'
import React from 'react'


import "@fontsource/questrial"
import "@fontsource/mukta"

const Sample = (props) => {
    const sample = props.sample
    return (
        <Card sx={{ m:2,color:"white",background:"#313131", border:1,borderRadius:1,borderColor:"black"}}>
            <CardMedia
                component="img"
                alt="Canary"
                image={require("../../Assets/Samples/" + sample.image)}
                sx={{p:5,background:"#4D4D4D",width:400,mx:"auto",my:3,display:{xs:"none",sm:"block"}}}

            />
            <CardMedia
                component="img"
                alt="Canary"
                image={require("../../Assets/Samples/" + sample.image)}
                sx={{p:5,background:"#4D4D4D",width:200,mx:"auto",my:3,display:{xs:"block",sm:"none"}}}

            />
                <Box sx={{p:3}}>
                    <CardContent sx={{background:"#313131"}}>
                        <Typography gutterBottom variant="h5" component="div" style={{fontFamily:"Questrial"}}>
                        {sample.title}
                        </Typography>
                        <Typography variant="body2" style={{fontFamily:"Mukta"}}>
                        {sample.paragraph}
                        </Typography>
                    </CardContent>
                    <CardActions sx={{mt:4}} style={{float:"right"}}>
                        <Button variant="outlined" sx={{background:"white","&:hover":{backgroundColor: "#FFF",borderColor:"black"},border:1,borderRadius:2,borderColor:'black' }}><a rel="noreferrer" href= {sample.link} target="_blank" style={{textDecoration:"none",color:"black",background:"white"}}>Open Website</a></Button>
                    </CardActions>
                </Box>
        </Card>
  )
}

export default Sample